/** 결제수단 앱 modal case */
export const PaymentMethodsModalCase = {
    /** 결제수단 조회 실패 */
    UNABLE_TO_SUBSCRIBE_ORDER_SHEET: 'UNABLE_TO_SUBSCRIBE_ORDER_SHEET',
    /** 만료된 디컨정기 결제수단 주문서 조회 */
    EXPIRED_ORDER_SHEET: 'EXPIRED_ORDER_SHEET',
    /** 충전결제 충전 금액 > 머니 한도(200만원) + 보유포인트 사용 OFF 시도 */
    RECHARGE_PAYMENT_UNABLE_BY_POINT_TOGGLE: 'RECHARGE_PAYMENT_UNABLE_BY_POINT_TOGGLE',
} as const

export type PaymentMethodsModalCaseValues = Constant<typeof PaymentMethodsModalCase>

/** 결제수단 앱 외에서도 사용 시 ModalCase를 merge하여 사용 */
export const ModalCase = PaymentMethodsModalCase

export type ModalCaseValues = Constant<typeof ModalCase>
